import { FreestyleActionTypes, FreestyleReducerActions, FreestyleButtonEventData } from "types/freestyle.action.types";
import FreestyleController from "components/Scene/Freestyle/Freestyle";

export const initFreestyle = (): FreestyleReducerActions =>
  ({
    type: FreestyleActionTypes.INIT_FREESTYLE,
  })

export const setFreestyleApi = (payload: FreestyleController): FreestyleReducerActions => 
  ({
    type: FreestyleActionTypes.SET_FREESTYLE_API,
    payload
  })

export const toggleContentOpened = (payload?: boolean): FreestyleReducerActions => 
  ({
    type: FreestyleActionTypes.TOGGLE_CONTENT_OPENED,
    payload
  })

export const stopFreestyle = (): FreestyleReducerActions => 
  ({
    type: FreestyleActionTypes.STOP_FREESTYLE
  })

export const ThrowButtonEvent = (payload: FreestyleButtonEventData): FreestyleReducerActions => 
  ({
    type: FreestyleActionTypes.BUTTON_EVENT,
    payload
  })


export const incrementCounter = (id: string, dir: 1 | -1): FreestyleReducerActions =>
  ({
    type: FreestyleActionTypes.INCREMENT_COUNTER,
    payload: {
      id,
      dir
    }
  })

